import { AlertBox } from 'shared/ui/AlertBox';
import { Button } from 'shared/ui/Button';
import { useModalsActions } from 'shared/ui/SideModal';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

import { CreateEmailsModal } from './CreateEmailsModal';
import { ManageEmailsModal } from './ManageEmailsModal';

const EMAILS_MAX_COUNT = 3;

export interface EditEmailsProps {
  campaignId: number;
  emails?: string[];
}

export function EditEmails({ campaignId, emails }: EditEmailsProps) {
  const { open } = useModalsActions();

  const emailList =
    !!emails &&
    emails.slice(0, EMAILS_MAX_COUNT).map((value, index) => {
      const showDot = index === emails.length - 1 && emails.length <= EMAILS_MAX_COUNT;
      const showMoreText = emails.length > EMAILS_MAX_COUNT && index === EMAILS_MAX_COUNT - 1;

      return (
        <div
          className="text-sm"
          key={value}
          {...getDataAutoTestAttributes(['manage-email-address']).attributes}
        >
          {value}
          {showDot ? '.' : ','}
          {showMoreText && <span className="text-slate-700"> +{emails.length - EMAILS_MAX_COUNT} more</span>}
        </div>
      );
    });

  const manageClick = () => {
    if (!emails?.length) {
      open(
        <CreateEmailsModal
          campaignId={campaignId}
          emails={['']}
        />
      );
    } else {
      open(
        <ManageEmailsModal
          campaignId={campaignId}
          emails={emails}
        />
      );
    }
  };

  return (
    <>
      <div className="my-8 border-t border-slate-100" />
      <div className="mb-4 flex items-center justify-between">
        <div className="text-lg font-semibold">Email notifications</div>
        <Button
          dataTestId="TestId_manage_email_notifications"
          type="button"
          onClick={manageClick}
          variant="outline"
          size="medium"
          {...getDataAutoTestAttributes(['button-manage-email-notifications'])}
        >
          Manage
        </Button>
      </div>
      {!emails?.length ? (
        <AlertBox
          iconClass="text-deep-blue-500"
          iconName="email"
          className="border-deep-blue-100"
        >
          <div className="mb-2 font-semibold text-slate-900">Email addresses have not been added</div>
          <div className="text-slate-700">Add email addresses to begin receiving notifications for new leads.</div>
        </AlertBox>
      ) : (
        <>
          <div className="mb-1 text-xs">Email addresses that receive notifications for each new lead.</div>
          {emailList}
        </>
      )}
    </>
  );
}
